import "./Title.css";

const Title = () => {
  return (
    <div className="Title">
      Currency converter
      <img src="/favicon.png" alt="dollar" />
    </div>
  );
};

export default Title;
